export const chats = {
  chatListChatIfoAttachmentsText: 'Allegati inviati',
  chatListChatNoMessagesText: 'Ancora nessun messaggio',
  chatArchivedTitle: 'Chat archiviate',
  chatsCreatePrivateCurtainTitle: 'Nuova chat',
  chatsCreatePrivateCurtaiSearchInputPlaceholder: 'Cerca',
  chatsCreatePrivateCurtainCreateButtonTitle: 'Crea',
  chatCreateButtonTitle: 'Avanti',
  chatCreateNewGroupHeader: 'Nuovo gruppo',
  chatGroupNameInputTitle: 'Nome gruppo',
  chatLogoTitle: 'Modifica',
  chatCreateGroupButtonTitle: 'Crea gruppo',
  chatRequiredFieldsAlert: 'Il nome del gruppo deve essere specificato!',
  chatsCreateGroupChatLongTitleAlertText: 'Si prega di utilizzare un titolo più breve!',
  chatsCreateGroupChatLBigImageAlertText: "Si prega di scegliere un'immagine più piccola!",
  chatsNewChatInputPlaceholder: 'Scrivi un messaggio',
  chatsNewChatAddedBigImageAlertText: "Si prega di scegliere un'immagine più piccola!",
  chatOwnersArchiveOptionText: 'Archivia',
  chatOwnersEditGroupOptionText: 'Modifica',
  chatOwnersManageGroupOptionText: 'Gestisci membri',
  chatOwnersChangeGroupOptionText: 'Cambia proprietario gruppo',
  chatOwnersLeaveGroupOptionText: 'Abbandona',
  chatOwnersDeleteGroupOptionText: 'Elimina chat',
  chatpopupArchivedTitle: 'Archivia chat',
  chatpopupArchivedDescription: 'Sei sicuro?',
  chatArchiveGroupButtonTitleYes: 'Conferma',
  chatArchiveGroupButtonTitleCancel: 'Annulla',
  chatEditGroupHeader: 'Modifica chat',
  chatEditGroupEditLogoTitle: 'Modifica',
  chatEditGroupButtonTitle: 'Salva',
  chatGroupEditAlertText: 'Salvataggio riuscito!',
  chatManageGroupHeader: 'Gestione',
  chatManageGroupButtonTitle: 'Aggiungi membro',
  chatManageGroupSaveButtonTitle: 'Salva',
  chatAddUsersGroupHeader: 'Aggiungi membri',
  chatAddUsersGroupButtonTitle: 'Conferma',
  chatAddUsersGroupSearchInputPlaceholder: 'Cerca',
  chatOwnershipTransferHeader: 'Trasferimento proprietà',
  chatOwnershipTransferSearchInputPlaceholder: 'Cerca',
  chatOwnershipTransferButtonTitle: 'Conferma',
  chatOwnerMarkText: '(tu)',
  chatOwnershipTransferAlertText: 'Proprietà trasferita!',
  chatOwnerLeaveGroupTitle: 'Abbandona il gruppo',
  chatOwnerLeaveGroupDescription: 'Sei un proprietario della chat, quindi devi assegnare un nuovo proprietario prima di uscire.',
  chatOwnerLeaveGroupButtonTitleYes: 'Scegli',
  chatOwnerLeaveGroupButtonTitleNo: 'Annulla',
  chatsGroupChatUsersCurtanArchOptionTitle: 'Archivia',
  chatsGroupChatUsersCurtanMembersOptionTitle: 'Membri chat',
  chatsGroupChatUsersCurtanLeaveOptionTitle: 'Abbandona',
  chatsGroupChatMemberCurtainTitle: 'Membri chat',
  chatsGroupChatMemberCurtainSearchInputPlaceholder: 'Cerca',
  chatsGroupChatMemberCurtainOwnerMarkText: '(proprietario)',
  chatsGroupChatLeavePopupTitle: 'Abbandona',
  chatsGroupChatLeavePopupText: 'Sei sicuro?',
  chatsGroupChatLeavePopupCancelButtonTitle: 'Annulla',
  chatsGroupChatLeavePopupConfirmButtonTitle: 'Conferma',
  chatDeleteGroupTitle: 'Elimina chat',
  chatDeleteGroupDescription: 'La chat e la sua cronologia verranno eliminate per tutti i partecipanti, procedere?',
  chatDeleteGroupButtonTitleYes: 'Conferma',
  chatDeleteGroupButtonTitleNo: 'Annulla',
  chatsPrivateChatCurtainArchOptionTitle: 'Archivia',
  chatsEditMessage: 'Modifica messaggio',
  chatsCopyMessage: 'Copia messaggio',
  chatsDeleteMessage: 'Elimina messaggio',
  chatsSelectMessage: 'Seleziona messaggio',
  chatMarkTextEdit: '(modificato)',
  chatCopyMessageAlertText: 'Messaggio copiato!',
  chatDeleteMessageTitle: 'Elimina messaggio',
  chatDeleteMessageDescription: 'Eliminare questo messaggio?',
  chatDeleteMessageButtonTitleYes: 'Conferma',
  chatDeleteMessageButtonTitleNo: 'Annulla',
  chatSelectButtonDelete: 'Annulla',
  chatSelectButtonNo: 'Elimina',
  chatDeleteMessagesTitle: 'Elimina messaggi',
  chatDeleteMessagesDescription: 'Eliminare questi messaggi?',
  chatDeleteMessagesButtonTitleYes: 'Conferma',
  chatDeleteMessagesButtonTitleNo: 'Annulla',
  chatArchiveButtonRestore: 'Ripristina',
  chatArchiveButtonNo: 'Elimina',
  chatNoUsersCurtainTitle: 'Ops!',
  chatsNoUsersCurtainText: 'Sembra che non ci siano altri utenti tranne te. Invita amici per iniziare a chattare.',
  chatsNoUsersCurtainCancelButtonTitle: 'Annulla',
  chatsNoUsersCurtainCopyButtonTitle: 'Copia link app',
  chatsAppLinkCopiedAlertText: 'Link copiato!',
  chatsTooFewUsers: 'Seleziona almeno un utente per iniziare a chattare!',
  chatsError: 'Qualcosa è andato storto!'
}
